import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://api.samhospital.org/api",
   baseURL: "https://api.hms-pk.com/api",  
  // baseURL: 'http://192.168.100.27:5050/api',
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("⚠️ Unauthorized request — handle token or redirect here.");
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
